export default __webpack_public_path__ + "static/media/AneomiClosed1.528d8f60.jpg";